import { useRecoilValue } from "recoil";
import { userSimpleAtom } from "recoil/userSimpleAtom";
import useGoogleLoginV2 from "../../hooks/useGoogleLoginV2";
import LoginButtonTemplatePromotion from "./LoginButtonTemplatePromotion";
import useAutoLoginPromotion from "../../hooks/useAutoLoginPromotion";

export default function GoogleLoginButtonPromotion({
  render,
}: {
  render?: (props: {
    onClick: (e?: any) => void;
    disabled?: boolean;
  }) => JSX.Element;
}) {
  useAutoLoginPromotion();
  const user = useRecoilValue(userSimpleAtom);
  const { handleGoogleLogin, isLoading } = useGoogleLoginV2();

  return (
    <LoginButtonTemplatePromotion
      loginType="google"
      action={handleGoogleLogin}
      isLoggedIn={!!user?.accessToken}
      isLoading={isLoading}
    />
  );
}
